<main>
    <section class="hero-trabaja">
        <div class="contenedor">
            <div class="imagen-hero-trabaja"></div>
            <div class="texto-hero-trabaja contenedor-blanco">
                <div class="circulo-azul-hero circulo-azul-decorativo"></div>
                <h1 class="titulo-principal">Trabaja con nosotros</h1>
                <p class="parrafo-contenido">En Corporación Rehobot reconocemos que nuestro mayor recurso es el <strong>humano</strong>. Por ello, buscamos personas <strong>comprometidas, capacitadas y con vocación de trabajo en equipo</strong>, que deseen aportar a proyectos que mejoren el acceso al agua y fortalezcan la infraestructura hidráulica del país.</p>
            </div>    
        </div>
    </section>

    <section class="seccion-especialidades">
        <div class="contenedor">
            <h2>Actualmente buscamos personal especializado en:</h2>
            <div class="contenido-especialidades">
                
                <div class="lista-especialidades">
                    <div class="especialidad" *ngFor="let item of especialidades">
                        <div class="icono-check"></div>
                        <span>{{ item }}</span>
                    </div>
                </div>

                <div class="imagen-especialidades">
                    </div>
            </div>
        </div>
    </section>

    <section class="seccion-formulario">
        <div class="contenedor">
            <div class="circulo-azul-formulario"></div>
            
            <div class="formulario-contenedor">
                <h2>Queremos conocerte</h2>
                
                <form class="formulario-trabajo" [formGroup]="trabajaForm" (ngSubmit)="onSubmit()">
                    
                    <div class="campo-formulario">
                        <label for="nombre">Nombre completo*</label>
                        <input type="text" id="nombre" formControlName="nombre" placeholder="Tu nombre aquí" maxlength="255">
                    </div>
                    
                    <div class="campos-linea">
                        <div class="campo-formulario">
                            <label for="email">Correo electrónico*</label>
                            <input type="email" id="email" formControlName="email" placeholder="ejemplo@correo.com" maxlength="255">
                        </div>
                        <div class="campo-formulario">
                            <label for="telefono">Teléfono*</label>
                            <input type="tel" id="telefono" formControlName="telefono" placeholder="+51 999 999 999" maxlength="20">
                        </div>
                    </div>
                    
                    <div class="campo-formulario">
                        <label for="carrera">Carrera o especialidad*</label>
                        <input type="text" id="carrera" formControlName="carrera" placeholder="Nombre de tu carrera o especialidad" maxlength="255">
                    </div>
                    
                    <div class="campos-linea">
                        <div class="campo-formulario">
                            <label>Puesto al que postulas*</label>
                            <div class="custom-select" id="customSelectPuesto">
                                <div class="custom-select-selected" (click)="toggleDropdown()">
                                    {{ puestoSeleccionadoLabel }}
                                </div>
                                <div class="custom-select-options" *ngIf="dropdownOpen">
                                    <div *ngFor="let puesto of puestos" 
                                         (click)="seleccionarPuesto(puesto)"
                                         [class.selected]="trabajaForm.get('puesto')?.value === puesto.value">
                                        {{ puesto.label }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="campo-formulario">
                            <label for="cv">CV*</label>
                            <div class="archivo-input">
                                <input type="file" id="cv" (change)="onFileSelected($event)" accept=".pdf,.doc,.docx" style="display: none;">
                                <label for="cv" class="archivo-label">
                                    <img class="archivo-icono" src="../../../assets/svg/clip.svg" alt="clip"> <span class="archivo-texto">{{ nombreArchivoSeleccionado }}</span>
                                    <span class="archivo-formatos">Tamaño máximo 5MB (.PDF, .DOC)</span>
                                </label>
                            </div>
                            <div class="error-text" *ngIf="trabajaForm.get('cv')?.invalid && trabajaForm.get('cv')?.touched" style="color: red; font-size: 0.8rem; margin-top: 5px;">
                                * Debes adjuntar tu CV.
                            </div>
                        </div>
                    </div>
                    
                    <button type="submit" class="btn-enviar" [disabled]="isLoading || trabajaForm.invalid" [class.loading]="isLoading">
                        <span *ngIf="!isLoading" class="btn-texto">Enviar solicitud</span>
                        </button>

                </form>
            </div>
        </div>
    </section>
</main>